/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from "react";
import { Formik } from "formik";

import {
  intlShape,
  apiShape,
  withApi,
  SwitchInput,
  Details,
  notifierShape,
  withNotifier,
  withIntl,
  ActionBar,
  htmlFormat,
  htmlLink,
  withBrowser,
  browserShape,
  withFlipper,
  userShape,
  withUser,
  ContextualHelp,
} from "lcm-iot-commons";
import { FormattedMessage } from "react-intl";

import CONFIGURATION from "lcm-iot-commons/client/lib/configuration";

type Props = {
  intl: intlShape;
  user: userShape;
  browser: browserShape;
  api: apiShape;
  notifier: notifierShape;
  flipper: {
    demoDataActive?: boolean;
  };
};

export function DemoDataHandler({
  notifier,
  api,
  intl,
  flipper,
  user,
  browser,
}: Props) {
  if (!user || !flipper.demoDataActive) return null;
  const [activated, setActivation] = useState(user.demoDataActive);
  const [switchDisabled, setSwitchDisabled] = useState(false);

  const saveDemoDataActivationState = async () => {
    setSwitchDisabled(true);
    try {
      if (activated) {
        await api.delete("/users/current/demo_data");
        notifier.showSuccess(
          intl.formatMessage({
            id: "user_profile.demo_data_deactivation_success_notification",
          }),
        );
      } else {
        await api.post("/users/current/demo_data");
        notifier.showSuccess(
          intl.formatMessage({
            id: "user_profile.demo_data_activation_success_notification",
          }),
        );
      }
      setActivation((prev) => !prev);
      setTimeout(() => {
        browser.redirectToExtern(`${CONFIGURATION.BASE_URL}`);
      }, 2000);
    } catch (apiErrors) {
      notifier.showError(api.translateError(apiErrors));
    } finally {
      setSwitchDisabled(false);
    }
  };

  const renderForm = (formProps: $TSFixMe) => (
    <>
      <ActionBar>
        <h2 id="user-profile-demo-data">
          <FormattedMessage id="user_profile.demo_data" />
          <ContextualHelp
            title={intl.formatMessage({ id: "user_profile.demo_data" })}
            interactive
          >
            <p>
              <FormattedMessage
                id="user_profile.demo_data.description"
                values={{
                  ...htmlFormat,
                  // @ts-expect-error TS(2322) FIXME: Type '(...chunks: any[]) => Element' is not assign... Remove this comment to see the full error message
                  a: htmlLink({
                    href: CONFIGURATION.HELP_URL_DEMODATA,
                    target: "_blank",
                  }),
                }}
              />
            </p>
          </ContextualHelp>
        </h2>
      </ActionBar>
      <Details>
        <form id="demo-data-form" noValidate>
          <SwitchInput
            {...formProps}
            id="demo-data-switch-input"
            values={{ "demo-data-switch-input": activated }}
            handleChange={saveDemoDataActivationState}
            name="demo-data-switch-input"
            disabled={switchDisabled}
          />
        </form>
      </Details>
    </>
  );

  return (
    <Formik
      id="demo-data-formik"
      initialValues={{}}
      onSubmit={/* istanbul ignore next */ () => {}}
    >
      {renderForm}
    </Formik>
  );
}

export default withBrowser(
  withNotifier(withUser(withFlipper(withApi(withIntl(DemoDataHandler))))),
);
